/*global window */
import React, { useContext, useMemo, useState } from 'react';
import { MdOutlinePhone } from 'react-icons/md';
import { FiMail } from 'react-icons/fi';
import { FaRegUser } from 'react-icons/fa';
import AppContext from './context/AppContext';
import '../styles/HeaderBar.css';
import { useNavigate } from 'react-router-dom';
import { CustomerContext } from './context/CustomerContext';

const VERTICAL_SEPARATOR = 'vertical-separator';
const DROPDOWN_ITEM = 'dropdown-item';

const HeaderBar = () => {
    const {
        customerData,
    } = useContext(CustomerContext);
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);
    const { appContext } = useContext(AppContext);
    const phoneNumber = useMemo(
        () => appContext.config.contactPhoneNumber,
        [appContext.config.contactPhoneNumber],
    );
    const storeEmail = useMemo(
        () => appContext.config.storeEmail,
        [appContext.config.storeEmail],
    );
    return (
        <div
            className={'top-bar desktop-only'}>
            <div
                className={'top-bar--section'}>
                <div
                    className={'contact-info'}>
                    <span>
                        <MdOutlinePhone
                            size={'18px'}
                            color={'white'} />
                        <a
                            href={`tel:${phoneNumber}`}
                            className={'text-white'}>
                            {phoneNumber}
                        </a>
                    </span>
                    <div
                        className={VERTICAL_SEPARATOR}>
                    </div>
                    <span>
                        <FiMail
                            size={'18px'}
                            color={'white'} />
                        <a
                            className={'text-white'}
                            href={`mailto:${storeEmail}`}>
                            {storeEmail}
                        </a>
                    </span>
                    <div
                        className={VERTICAL_SEPARATOR}>
                    </div>
                </div>

                <button
                    className={'account-section position-relative'}
                    onMouseEnter={() => setShowDropdown(true)}
                    onMouseLeave={() => setShowDropdown(false)}
                >
                    <div
                        className={VERTICAL_SEPARATOR}>
                    </div>
                    <span
                        className={'account-link text-white'}>
                        <FaRegUser
                            size={'16px'}
                            color={'white'} /> Account
                    </span>
                    <div
                        className={VERTICAL_SEPARATOR}>
                    </div>
                    {showDropdown && (
                        (!customerData || Object.keys(customerData).length === 0) ? <div
                            className={'custom-dropdown-menu'}>
                            <button
                                onClick={() => {
                                    window.location.assign('/login');
                                }}
                                className={DROPDOWN_ITEM}>Sign in</button>
                            <button
                                onClick={() => {
                                    window.location.assign('/register');
                                }}
                                className={DROPDOWN_ITEM}>Register</button>
                        </div> : <div
                            className={'custom-dropdown-menu'}>
                            <button
                                onClick={() => {
                                    navigate('/myaccount.asp');
                                }}
                                className={DROPDOWN_ITEM}>Manage Account</button>
                            <button
                                onClick={() => {
                                    window.location.assign('/logout');
                                }}
                                className={DROPDOWN_ITEM}>Sign Out</button>
                        </div>
                    )}
                </button>
            </div>
        </div>
    );
};

HeaderBar.propTypes = {
};

export default HeaderBar;
